import { useState } from "react";
import { Box, Text, HStack, Flex } from "@chakra-ui/react";
import closeicon from "../../assets/kudzu-plus-images/Close-white.png";

const MembershipBanner = ({ handleExploreClick, handleCloseClick }) => {

    return (
        <Box
            className="w-full bg-[#1E2A3A] text-white fixed bottom-0 left-0 z-50 h-[100px] flex items-center"
            py={2}
            px={40}
        >
            <Flex className="w-full items-center" justify="space-between">
                <Text fontSize="sm" className="text-gray-300 text-[22px] pl-[70px]" fontFamily="'Source Serif Pro', serif">
                    <Text as="span" fontWeight="bold" color="#94C3E8">Kudzu+&nbsp;</Text>
                    Explore your new membership perks
                </Text>
                <HStack spacing={4} className="ml-auto" gap="1rem" paddingLeft="20px">
                    <button
                        onClick={handleExploreClick}
                        className="text-white text-sm px-7 py-1 rounded-full bg-gradient-to-r from-blue-500 to-teal-400 hover:opacity-90 h-[55px] w-[165px]"
                    >
                        Explore
                    </button>
                    <button onClick={handleCloseClick} className="text-sm">
                        <img src={closeicon} alt="Close" className="w-4 h-4" />
                    </button>
                </HStack>
            </Flex>
        </Box>
    );
};
export default MembershipBanner;
